import React from "react";
import {
  Cloud,
  Database,
  FileText,
  Sheet,
  Zap,
} from "lucide-react";

// Type definitions  
type ActiveSection = "Daily Report" | "Weather" | "Inverters" | "Breakdowns" | "Plant Meters" | "";

interface SidebarSection {
  label: ActiveSection;
  icon: any;
}

interface SidebarProps {
  active: ActiveSection;
  setActive: (value: ActiveSection) => void;
}

const sections: SidebarSection[] = [
  { label: "Daily Report", icon: Sheet },    // Changed to match your type
  { label: "Inverters", icon: Database },     
  { label: "Weather", icon: Cloud },         
  { label: "Breakdowns", icon: FileText },   
  { label: "Plant Meters", icon: Zap },     
];

const Sidebar = ({ active, setActive }: SidebarProps) => {
  return (
    <div className="fixed top-16 left-0 z-50 w-44 bg-white/90 backdrop-blur-md shadow-lg border-r border-gray-200 h-[calc(100vh-4rem)] flex flex-col pt-4">
      
      {/* Compact Sidebar Header */}
      <div className="px-3 mb-3">
        <h3 className="text-xs font-bold text-[#0084CF] uppercase tracking-wide">
          Data Sections
        </h3>
        <div className="h-0.5 bg-gradient-to-r from-[#0084CF] to-transparent mt-1"></div>
      </div>

      {/* Navigation Items */}
      <div className="flex-1 px-2 space-y-1">
        {sections.map((section) => {
          const Icon = section.icon;
          const isActive = active === section.label;

          return (
            <div
              key={section.label}
              onClick={() => setActive(section.label)} // This now works correctly
              className={`w-full flex items-center gap-2 px-3 py-2.5 cursor-pointer rounded-lg
                transition-all duration-200 group
                ${
                  isActive 
                    ? "bg-gradient-to-r from-[#0084CF] to-[#0066A3] text-white shadow-lg transform scale-105" 
                    : "hover:bg-gradient-to-r hover:from-[#0084CF]/10 hover:to-[#E3F0F9]/50 text-gray-700 hover:text-[#0084CF] hover:shadow-md"
                }`}
            >
              <Icon 
                size={18} 
                className={`shrink-0 transition-transform duration-200 ${
                  isActive ? "scale-110" : "group-hover:scale-105"
                }`} 
              />
              <span className="text-xs font-semibold truncate">
                {section.label}
              </span>
              
              {/* Active indicator */}
              {isActive && (
                <div className="ml-auto w-1.5 h-1.5 bg-white rounded-full"></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Compact Footer */}
      <div className="px-3 py-3 border-t border-gray-200">
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <div className="w-1.5 h-1.5 bg-[#0084CF] rounded-full"></div>
          <span className="truncate">DGR Viewer</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;